import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { ModelsImpactType } from '../../api/core/models';
import { ClientAction } from '../../model/client-model/client-action';
import { ActionsState, OutcomeAssessmentState, OutcomeAssessmentValueState } from './actions.types';

export const actionsEffectsActions = createActionGroup({
  source: 'Action Effects',
  events: {
    'Loaded actions': props<{ actionsList: ActionsState['actionsList'] }>(),
    'Loading actions failed': props<{ error: Error }>(),
    'Saved action': props<{ savedAction: Partial<ClientAction> }>(), // contains partial updates if against core

    'Create action success': props<{ action: ClientAction }>(),
    'Create action failed': props<{ error: Error }>(),

    'Delete action success': props<{ actionId: string }>(),
    'Delete action failed': props<{ error: Error }>(),

    'Reset state': emptyProps(),
  },
});

export const outcomeAssessmentsActions = createActionGroup({
  source: 'Outcome Assessments',
  events: {
    'Load outcome assessments success': props<{
      actionId: string;
      outcomeAssessments: OutcomeAssessmentState[];
    }>(),
    'Create outcome assessment success': props<{
      actionId: string;
      createdOutcomeAssessment: OutcomeAssessmentState;
    }>(),
    'Saved outcome assessment': props<{
      actionId: string;
      transitionElementId: string;
      savedOutcomeAssessment: {
        impactType: ModelsImpactType;
        description?: string;
        values?: OutcomeAssessmentValueState[];
      };
    }>(),
    'Delete outcome assessment success': props<{
      actionId: string;
      outcomeAssessmentId: string;
    }>(),
    'Delete transition element success': props<{
      transitionElementId: string;
    }>(),
    'Delete action success': props<{
      actionId: string;
    }>(),
    'Patched action connections success': props<{
      actionId: string;
      remainingTransitionElementIds: string[];
    }>(),
    'Clear outcome assessments': emptyProps(),
  },
});

export const actionsFacadeActions = createActionGroup({
  source: 'Actions Facade',
  events: {
    'Load actions': emptyProps(),
  },
});
